export default {"src":"/_next/static/media/benefit-dark.4a23e99c.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};